export function anonymizeIp(ip: string): string {
  const value = ip.trim();
  if (value.includes(':')) {
    const parts = value.split(':');
    return `${parts.slice(0, 3).join(':')}::`;
  }

  const parts = value.split('.');
  if (parts.length !== 4) return '[REDACTED]';
  return `${parts[0]}.${parts[1]}.${parts[2]}.0`;
}
